var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import Fade from '@mui/material/Fade';
import Collapse from '@mui/material/Collapse';
import { Flex } from '../../layout';
import { RatingSelector } from './RatingSelector';
import { FeedbackWrapper, Form, SendButton, ThankYouMessage } from './styledComponents';
export var Feedback = function (_a) {
    var _b = _a.rating, rating = _b === void 0 ? null : _b, _c = _a.comment, comment = _c === void 0 ? '' : _c, onSubmit = _a.onSubmit, onRatingChange = _a.onRatingChange, onCommentChange = _a.onCommentChange, props = __rest(_a, ["rating", "comment", "onSubmit", "onRatingChange", "onCommentChange"]);
    var _d = useState(false), showForm = _d[0], setShowForm = _d[1];
    //Controls lifecycle of the after submit message
    var _e = useState(false), isSubmitted = _e[0], setIsSubmitted = _e[1];
    var _f = useState(false), isFinished = _f[0], setIsFinished = _f[1];
    var handleRatingSelect = function (newRating) {
        var userIsChangingRating = newRating !== null;
        onRatingChange(userIsChangingRating ? newRating : null);
        if (!showForm) {
            setShowForm(true);
        }
    };
    var handleSubmit = function () {
        onSubmit();
        setIsSubmitted(true);
        setTimeout(function () {
            setIsFinished(true);
        }, 2000);
    };
    var renderFeedback = function () { return (<FeedbackWrapper data-testid="feedback" onClick={function (e) { return e.stopPropagation(); }} {...props}>
      <Collapse in={showForm} timeout={500}>
        <Form data-testid="additional-feedback-form">
          <span>Additional comments?</span>
          <textarea data-testid="additional-feedback-textarea" value={comment} onChange={function (e) {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            onCommentChange((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        }}/>
        </Form>
      </Collapse>
      <Flex>
        <RatingSelector selectedRating={rating} onSelect={handleRatingSelect} showInitialMessage={!showForm}/>
        {showForm ? (<SendButton data-testid="submit-feedback" disabled={!rating} onClick={handleSubmit}>
            Send
          </SendButton>) : null}
      </Flex>
    </FeedbackWrapper>); };
    return isSubmitted ? (<Fade data-testid="thank-you" in={!isFinished} timeout={1000} unmountOnExit>
      <ThankYouMessage>Thanks for your feedback!</ThankYouMessage>
    </Fade>) : (renderFeedback());
};
